import { APP_VERSION } from '@/lib/constants';

export function Logo({ size = "default" }: { size?: "default" | "small" }) {
  const iconSize = size === "small" ? 20 : 32;

  return (
    <div className="flex items-center gap-3">
      <img
        src={`/branding/v2-vector/liftforge-icon-v2.svg?v=${APP_VERSION}`}
        alt="LiftForge"
        width={iconSize}
        height={iconSize}
        style={{ flexShrink: 0 }}
      />
      <span
        style={{
          fontSize: size === "small" ? '14px' : '20px',
          color: '#F0F0F0',
          fontWeight: 700,
          letterSpacing: '1.2px',
          lineHeight: 1,
        }}
      >
        LIFTFORGE
      </span>
    </div>
  );
}
